import { useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { request_id_for } from '../rules_engine/logic';
import { keeps_request_id, write_error } from './adapters';

// A pending promise: a second submit while one is in flight is dropped, not sent.
const IGNORED = () => new Promise(() => {});

/*
 * a money write with a client_request_id. on_busy lets the host dialog lock its close; it is
 * called directly (not from an effect) so the unlock still lands when the form unmounts on success.
 */
const useIdempotentPost = (failed_text, new_id = uuidv4, on_busy = null) => {
  const idem = useRef(null);
  const in_flight = useRef(false);
  const [busy, setBusy] = useState(false);

  const send = (signature, post) => {
    if (in_flight.current) return IGNORED();
    in_flight.current = true;
    idem.current = request_id_for(idem.current, signature, new_id);
    setBusy(true);
    if (on_busy) on_busy(true);
    const settle = (result) => {
      in_flight.current = false;
      setBusy(false);
      if (on_busy) on_busy(false);
      return result;
    };
    return post(idem.current.id).then(
      (data) => {
        idem.current = null;
        return settle({ ok: true, data });
      },
      (e) => {
        const err = write_error(e, failed_text);
        if (!keeps_request_id(err)) idem.current = null;
        return settle({ ok: false, err, raw: e });
      }
    );
  };

  return { busy, send };
};

export default useIdempotentPost;
